import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ExecutionDetailResponse, TriggeredExecutionSummary } from '../types/TriggeredExecution'
import { ScriptFeedbackStep } from '../../mScripts/tessaScript/types/ScriptExecution'
import { getTriggeredExecutions, getExecutionDetail } from './thunks'

export interface TriggeredExecutionsState {
  list: TriggeredExecutionSummary[]
  detail: (ExecutionDetailResponse & { scriptFeedbackSteps: ScriptFeedbackStep[] }) | null
  loading: boolean
}

const initialState: TriggeredExecutionsState = {
  list: [],
  detail: null,
  loading: false
}

const triggeredExecutionsSlice = createSlice({
  name: 'triggeredExecutions',
  initialState,
  reducers: {
    clearTriggeredExecutionDetail(state) {
      state.detail = null
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getTriggeredExecutions.pending, state => {
        state.loading = true
      })
      .addCase(
        getTriggeredExecutions.fulfilled,
        (state, action: PayloadAction<TriggeredExecutionSummary[]>) => {
          state.list = action.payload
          state.loading = false
        }
      )
      .addCase(getTriggeredExecutions.rejected, state => {
        state.loading = false
      })
      .addCase(getExecutionDetail.pending, state => {
        state.loading = true
      })
      .addCase(
        getExecutionDetail.fulfilled,
        (
          state,
          action: PayloadAction<
            ExecutionDetailResponse & { scriptFeedbackSteps: ScriptFeedbackStep[] }
          >
        ) => {
          state.detail = action.payload
          state.loading = false
        }
      )
      .addCase(getExecutionDetail.rejected, state => {
        state.loading = false
      })
  }
})

export const { clearTriggeredExecutionDetail } = triggeredExecutionsSlice.actions
export const triggeredExecutionsReducer = triggeredExecutionsSlice.reducer
